import * as React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import { makeStyles } from "@mui/styles";
import Box from "@mui/material/Container";
import MainHeader from "../../components/MainHeader";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import { Link } from "react-router-dom";
import autoMergeLevel1 from "redux-persist/es/stateReconciler/autoMergeLevel1";
import * as palette from "../../utils/styledVariables";
import HeaderSecti from "../../components/HeaderSecti";
import Rodape from "../../components/Rodape";
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import EmailIcon from '@mui/icons-material/Email';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

const WhiteBox = styled(Box)`
  width:38rem;
  height: 30rem;
  margin: auto auto auto auto;
  border: 1px solid #df622e;
  border-radius: 0.5rem;
  color: #fff;
  overflow: hidden;
  text-align: center;
  background: rgba(255, 255, 255, 89%);
  animation: fadeIn;
  animation-duration: 1s;

  @media (max-width: 700px) {
    width: 38rem;
    height: 45rem;
  }
  @media (max-width: 360px) {
    width: 33rem;
    height: 45rem;
  }

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const ColorButton = styled(Button)(({ theme }) => ({
  color: theme.palette.getContrastText("#ffffff"),
  display: "flex",
  alignItems:"center",
  justifyContent:"center",
  
  backgroundColor: "#df622e",
  "&:hover": {
  backgroundColor: "#808080"
},
  // backgroundColor: "#ffffff",
  // "&:hover": {
  //   backgroundColor: "#dedede",
  // },
}));

const UseStyles = makeStyles((theme) => ({
  root: {
    overflow: "hidden",
    background: "#FFF",
     // "linear-gradient(180deg,rgba(116, 31, 138, 0.9) 35%,rgba(0, 0, 99, 1) 100%)",
    height: "60vh",
    display:"flex",
    alignItems:"center",
    justifyContent:"center",

  },
}));

export default function Help() {
  const classes = UseStyles();
  return (
    <React.Fragment>
      <HeaderSecti/>
      <CssBaseline />
      <MainHeader />
      <div className={classes.root}>
        <div className={classes.paperContainer} />
        <WhiteBox>
            <Typography
              variant="h4"
              component="div"
              gutterBottom
              sx={{color: "#df622e", fontFamily:"montserrat", fontWeight:"bold"}}
            >
              Como podemos te ajudar?
            </Typography>
            <Stack spacing={3} sx={{ mt: 4 }}>
              <Link to="/forgot">
                <ColorButton
                  variant="contained"
                  sx={{ width: "100%", color:"#fff", fontFamily:"montserrat" }}
                  size="large"
                >
                  <QuestionMarkIcon fontSize="small" style={{marginRight: "0.5rem"}}/>
                  Esqueci minha senha
                </ColorButton>
              </Link>
              <Link to="/recuperar-acesso">
                <ColorButton
                  variant="contained"
                  sx={{ width: "100%", color:"#fff", fontFamily:"montserrat", backgroundColor:"#255aa7"}}
                  size="large"
                >
                  <EmailIcon fontSize="small" style={{marginRight: "0.5rem", verticalAlign:"baseline",}}/>
                  Alterar o email cadastrado
                </ColorButton>
              </Link>
              <a href="https://wa.me/message/G622HMB7DH3KM1">
                <ColorButton
                  variant="contained"
                  sx={{ width: "100%", color:"#fff", fontFamily:"montserrat", backgroundColor:"#008000" }}
                  size="large"
                >
                  <WhatsAppIcon fontSize="small" style={{marginRight: "0.5rem"}}/>
                  Entre em contato conosco.
                  
                </ColorButton>
              </a>
              {/* <Link to="/deletar-conta">
                <ColorButton
                  variant="contained"
                  sx={{ width: "100%" }}
                  size="large"
                >
                  Quero deletar minha conta
                </ColorButton>
              </Link> */}
            </Stack>
        </WhiteBox>
      </div>
      <Rodape/>
    </React.Fragment>
  );
}
